import React, { useEffect } from 'react';
import { Form, Input, Select, Button, Row, Col, notification } from 'antd';
import Navbar from './Navbar';
import './ContactForm.css';

const { Option } = Select;

const ContactForm = () => {
  const [form] = Form.useForm();

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const response = await fetch('/backend/save_contact_info.php', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        });

        const data = await response.json();
        if (response.ok && !data.error) {
          form.setFieldsValue({
            mainPhone: data.mainPhone || '',
            otherContact: data.otherContact || '',
            preferredContactMethod: data.preferredContactMethod || '',
            contactPersonName: data.contactPersonName || '',
            contactDetails: data.contactDetails || '',
            contactType: data.contactType || '',
            staffName: data.staffName || '',
            staffContact: data.staffContact || '',
            additionalStaffContact: data.additionalStaffContact || '',
          });
        } else {
          notification.error({
            message: 'Erreur',
            description: data.error || 'Erreur lors de la récupération des informations de contact.',
            placement: 'topRight',
            duration: 3,
          });
        }
      } catch (error) {
        notification.error({
          message: 'Erreur',
          description: 'Une erreur s\'est produite lors de la récupération des informations.',
          placement: 'topRight',
          duration: 3,
        });
      }
    };

    fetchContactInfo();
  }, [form]);

  const onFinish = async (values) => {
    try {
      const response = await fetch('/backend/save_contact_info.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(values),
      });

      const data = await response.json();
      if (response.ok) {
        notification.success({
          message: 'Informations sauvegardées',
          description: 'Vos informations de contact ont été sauvegardées avec succès.',
          placement: 'topRight',
          duration: 3,
        });
      } else {
        notification.error({
          message: 'Erreur',
          description: data.error || 'Erreur lors de la sauvegarde des informations.',
          placement: 'topRight',
          duration: 3,
        });
      }
    } catch (error) {
      notification.error({
        message: 'Erreur',
        description: 'Une erreur s\'est produite lors de la sauvegarde des informations.',
        placement: 'topRight',
        duration: 3,
      });
    }
  };

  return (
    <>
      <Navbar />
      <div className="form-wrapper">
        <div className="contact-form-container">
          <h2>Contact</h2>
          <p>Manage your contact information and connections</p>

          <Form form={form} layout="vertical" onFinish={onFinish}>
            {/* Current Contact Info Section */}
            <h3>Current Contact Info</h3>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item name="mainPhone" label="Main Phone">
                  <Input placeholder="(123) 456-7890" size="large" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="otherContact" label="Other Contact">
                  <Input placeholder="Email or Social Media" size="large" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="preferredContactMethod" label="Preferred Contact Method">
                  <Select placeholder="Select preferred method" size="large">
                    <Option value="phone">Phone</Option>
                    <Option value="email">Email</Option>
                    <Option value="social">Social Media</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            {/* My Network Contact Section */}
            <h3>My Network Contact</h3>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item name="contactPersonName" label="Contact Person Name">
                  <Input placeholder="Contact Person Name" size="large" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="contactDetails" label="Contact Details">
                  <Input placeholder="Contact Details" size="large" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="contactType" label="Contact Type">
                  <Select placeholder="Select contact type" size="large">
                    <Option value="friend">Friend</Option>
                    <Option value="colleague">Colleague</Option>
                    <Option value="family">Family</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            {/* Service Provider Staff Contact Section */}
            <h3>Service Provider Staff Contact</h3>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item name="staffName" label="Staff Name">
                  <Input placeholder="Staff Name" size="large" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="staffContact" label="Staff Contact">
                  <Input placeholder="Phone or Email" size="large" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="additionalStaffContact" label="Additional Staff Contact">
                  <Input placeholder="Phone or Email" size="large" />
                </Form.Item>
              </Col>
            </Row>

            {/* Save Button */}
            <Form.Item>
              <Button type="primary" htmlType="submit" block size="large">
                Save
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </>
  );
};

export default ContactForm;